import { API_URL } from '~/config/environment';
import type { OriginName } from '~/interfaces/common';
import type { CheckAliasesAvailabilityResponse } from '~/routes/auth/login/-types/types';
import { fetchJson } from '~/utils/fetch-json';

export interface AllAvailableOrigins {
  namespace: OriginName;
  status: string;
  created_at: string;
  updated_at: string;
}

export const getAllAvailableOrigins = async (): Promise<
  AllAvailableOrigins[]
> => {
  const res = await fetch(`${API_URL}/origins`);

  return res.json();
};

interface OAuthAuthorization {
  type: string;
  value: Value;
  params: Params;
}

interface Params {
  domain: string;
  clientId: string;
  redirectUri: string;
  expires_at: string;
}

interface Value {
  authorizationUrl: string;
  state: string;
  nonce: string;
}

export const fetchAuthRegistration = async (
  namespace: OriginName,
  alias?: string,
): Promise<OAuthAuthorization> => {
  const url = new URL(`${API_URL}/origins/${namespace}/attest`);
  if (alias) {
    url.searchParams.set('alias', alias);
  }

  const res = await fetch(url.toString());

  return res.json();
};

export const checkAliasesAvailability = async (alias: string) => {
  const res = await fetchJson<CheckAliasesAvailabilityResponse>(
    `/aliases?alias=${alias}`,
    {},
    true,
  );

  return res;
};
